import * as actionType from "./actionTypes";
import { updateObject, createReducer, setItemEditing, updateItem, editItemProp, deleteItem } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  product: {
    byID: {},
    allIDs: [],
  },
  loadedCategoryID: null,
  collectionFilter: null,
  page: 0,
  pageSize: 25,
  totalProducts: 0,
  productEditing: null,
};

const receiveProducts = (state, action) => (
  updateObject(state, {
    product: action.product,
    loadedCategoryID: action.loadedCategoryID,
    collectionFilter: action.collectionFilter,
    page: action.page,
    pageSize: action.pageSize,
    totalProducts: action.totalProducts,
  })
);

//A single fully loaded product, merged into whatever the list already has.
//Deliberately leaves the pagination fields alone so that going back to the
//list does not lose the page that was loaded.
const receiveProduct = (state, action) => (
  updateObject(state, {
    product: updateObject(state.product, {
      byID: updateObject(state.product.byID, {
        [action.product.id]: action.product,
      }),
      allIDs: state.product.allIDs.includes(action.product.id) ? state.product.allIDs : [...state.product.allIDs, action.product.id],
    }),
  })
);

const reorderProducts = (state, action) => (
  updateObject(state, {
    product: updateObject(state.product, {
      allIDs: action.newOrder,
    }),
  })
);

const reducer = createReducer(initialState, {
  [actionType.RECEIVE_PRODUCTS]: receiveProducts,
  [actionType.RECEIVE_PRODUCT]: receiveProduct,

  [actionType.SET_PRODUCT_EDITING]: setItemEditing("product"),
  [actionType.EDIT_PRODUCT_PROP]: editItemProp("product"),
  [actionType.UPDATE_PRODUCT]: updateItem("product"),
  [actionType.DELETE_PRODUCT]: deleteItem("product"),
  [actionType.REORDER_PRODUCTS]: reorderProducts,
});

export default reducer;

// SELECTORS

export const getProducts = (state) => (
  state.product.allIDs.map((id) => state.product.byID[id])
);

export const getProductEditing = (state) => (
  state.productEditing
);

export const getLoadedCategoryID = (state) => (
  state.loadedCategoryID
);

export const getCollectionFilter = (state) => (
  state.collectionFilter
);

export const getPage = (state) => state.page;
export const getPageSize = (state) => state.pageSize;
export const getTotalProducts = (state) => state.totalProducts;
